import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        root: {},
        noDisplay: {
            display: 'none',
        },
        addresses: {
            color: theme.palette.secondary[900],
        },
    }
})

export default useStyles
